import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "@/axios";
import { routes } from "@/utils/urls";

export interface DemographicsResponse {
  status: number;
  data: {
    memberFirstName: string;
    memberLastName: string;
    memberDob: string;
    agencyName: string;
    memberGender: string;
    networkName: string;
    memberRace: string;
    memberPhone: string;
    memberAddress1: string;
    memberAddress2: string;
    memberCity: string;
    memberState: string;
  };
}

export interface DemographicsState {
  byMemberId: Record<string, DemographicsResponse["data"] | undefined>;
  loading: boolean;
  error: string | null;
}

const initialState: DemographicsState = {
  byMemberId: {},
  loading: false,
  error: null,
};

const DEMOGRAPHICS_DUMMY: DemographicsResponse = {
  status: 200,
  data: {
    memberFirstName: "lekjfskbher",
    memberLastName: "sdvklnjadlfnv",
    memberDob: "1985-03-15T00:00:00.000Z",
    agencyName: "Care Agency NY",
    memberGender: "M",
    networkName: "Network East",
    memberRace: "White",
    memberPhone: "555-0101",
    memberAddress1: "123 Main St",
    memberAddress2: "Apt 4B",
    memberCity: "New York",
    memberState: "NY",
  },
};

export const fetchDemographics = createAsyncThunk<
  { memberId: string; data: DemographicsResponse["data"] },
  { memberId: string },
  { rejectValue: string }
>(
  "demographicsByMemberId/fetch",
  async ({ memberId }, { rejectWithValue }) => {
    try {
      try {
        const res = await api.get(`${routes.cards.demographics}/${memberId}`);
        const data = res.data as DemographicsResponse;
        if (data && data.data) {
          return { memberId, data: data.data };
        }
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      } catch (_e) {
        // fall back to dummy
      }
      return { memberId, data: DEMOGRAPHICS_DUMMY.data };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (_e) {
      return rejectWithValue("Failed to fetch demographics");
    }
  }
);

const demographicsSlice = createSlice({
  name: "demographicsByMemberId",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDemographics.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDemographics.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        state.byMemberId[action.payload.memberId] = action.payload.data;
      })
      .addCase(fetchDemographics.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to fetch demographics";
      });
  },
});

export default demographicsSlice.reducer;


